import { render, staticRenderFns } from "./student-pickup-table.vue?vue&type=template&id=d4a5b97a&scoped=true"
import script from "./student-pickup-table.vue?vue&type=script&lang=js"
export * from "./student-pickup-table.vue?vue&type=script&lang=js"
import style0 from "./student-pickup-table.vue?vue&type=style&index=0&id=d4a5b97a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a5b97a",
  null
  
)

export default component.exports